export interface Category {
  name: string;
  url: string;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    name: 'Обувь',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20sneaker%20photography%20on%20neutral%20beige%20background%2C%20clean%20product%20shot%20with%20soft%20natural%20lighting%2C%20editorial%20style%2C%20warm%20tones%2C%20professional%20ecommerce%20aesthetic%20with%20gentle%20shadows%20and%20elegant%20composition&width=800&height=600&seq=cat-card-0-shoes&orientation=landscape',
  },
  {
    name: 'Худи / Свитеры',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20beige%20hoodie%20laid%20flat%20on%20neutral%20cream%20surface%2C%20minimalist%20fashion%20photography%2C%20warm%20natural%20light%2C%20clean%20editorial%20style%2C%20cozy%20aesthetic%20with%20gentle%20fabric%20texture%20and%20elegant%20composition&width=800&height=600&seq=cat-card-1-hoodies&orientation=landscape',
  },
  {
    name: 'Футболки',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20white%20t-shirt%20on%20neutral%20warm%20beige%20background%2C%20clean%20product%20photography%2C%20soft%20natural%20lighting%2C%20editorial%20fashion%20shot%2C%20elegant%20simple%20composition%20with%20gentle%20fabric%20folds&width=800&height=600&seq=cat-card-2-tshirts&orientation=landscape',
  },
  {
    name: 'Куртки',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20lightweight%20jacket%20on%20neutral%20beige%20backdrop%2C%20minimalist%20fashion%20photography%2C%20soft%20daylight%2C%20clean%20editorial%20composition%2C%20warm%20earthy%20tones%20with%20gentle%20shadows&width=800&height=600&seq=cat-card-3-jackets&orientation=landscape',
  },
  {
    name: 'Штаны / Шорты',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Casual%20beige%20trousers%20on%20clean%20cream%20surface%2C%20minimalist%20product%20photography%2C%20soft%20natural%20light%2C%20editorial%20style%2C%20warm%20neutral%20tones%20with%20elegant%20fabric%20draping&width=800&height=600&seq=cat-card-4-pants&orientation=landscape',
  },
  {
    name: 'Головные уборы',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20neutral%20cap%20on%20warm%20beige%20background%2C%20minimalist%20accessory%20photography%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20shot%2C%20elegant%20simple%20composition&width=800&height=600&seq=cat-card-5-headwear&orientation=landscape',
  },
  {
    name: 'Комплекты',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Coordinated%20clothing%20set%20on%20neutral%20cream%20background%2C%20minimalist%20fashion%20photography%2C%20soft%20daylight%2C%20clean%20editorial%20composition%2C%20warm%20aesthetic%20with%20harmonious%20color%20palette&width=800&height=600&seq=cat-card-6-sets&orientation=landscape',
  },
  {
    name: 'Нижнее белье',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20neutral%20undergarments%20on%20clean%20beige%20surface%2C%20minimalist%20intimate%20photography%2C%20gentle%20natural%20light%2C%20tasteful%20editorial%20style%2C%20warm%20tones%20with%20delicate%20fabric%20texture&width=800&height=600&seq=cat-card-7-underwear&orientation=landscape',
  },
  {
    name: 'Джерси',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Sporty%20jersey%20on%20neutral%20cream%20backdrop%2C%20minimalist%20sportswear%20photography%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20style%2C%20warm%20tones%20with%20athletic%20aesthetic&width=800&height=600&seq=cat-card-8-jersey&orientation=landscape',
  },
  {
    name: 'Аксессуары',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20accessories%20on%20warm%20beige%20surface%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20product%20photography%2C%20sophisticated%20composition%20with%20gentle%20shadows&width=800&height=600&seq=cat-card-9-accessories&orientation=landscape',
  },
  {
    name: 'Сумки',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20leather%20bag%20on%20neutral%20cream%20background%2C%20clean%20product%20photography%2C%20soft%20natural%20light%2C%20editorial%20fashion%20shot%2C%20warm%20earthy%20tones%20with%20elegant%20composition&width=800&height=600&seq=cat-card-10-bags&orientation=landscape',
  },
  {
    name: 'Ремни',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20leather%20belt%20on%20neutral%20beige%20surface%2C%20minimalist%20accessory%20photography%2C%20soft%20daylight%2C%20clean%20editorial%20composition%2C%20warm%20tones%20with%20subtle%20texture&width=800&height=600&seq=cat-card-11-belts&orientation=landscape',
  },
  {
    name: 'Парфюмерия',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20perfume%20bottle%20on%20warm%20beige%20background%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20product%20photography%2C%20elegant%20sophisticated%20composition%20with%20gentle%20highlights&width=800&height=600&seq=cat-card-12-perfumes&orientation=landscape',
  },
  {
    name: 'Разное',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Assorted%20minimalist%20lifestyle%20products%20on%20neutral%20cream%20surface%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20photography%2C%20warm%20aesthetic%20with%20harmonious%20arrangement&width=800&height=600&seq=cat-card-13-other&orientation=landscape',
  },
];